
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.82.82c.912 0 1.693.339 2.344 1.016.677.651 1.016 1.432 1.016 2.344v5H.82V.82H2.5v5.86h6.68V.82h6.64zM7.578 5.078c-.495.495-1.08.742-1.758.742-.677 0-1.263-.247-1.758-.742-.494-.495-.742-1.08-.742-1.758 0-.677.248-1.263.743-1.757C4.556 1.067 5.143.82 5.82.82c.677 0 1.263.248 1.758.743.495.494.742 1.08.742 1.757 0 .677-.247 1.263-.742 1.758z","fill":"currentColor"}})])
          )
        }
      }
    